import { UPDATE_TEST_RESULT } from '../../constants/action-types';
import { ICurrentTest } from '../../constants/types';


export function updateCurrentTest(payload: ICurrentTest | null, newPath?: string) {
    return { type: UPDATE_TEST_RESULT, payload, path: newPath }
}